import React from "react";

export const isDistroEnabled = (email, user_type) => {
  // const emails = [
  //   "sound@CUSCINO.LA",
  //   "niki@hypelifebrands.com",
  //   "hey@futuresoundwithcuscino.com",
  //   "vijay@qashammer.com",
  //   "ethopialeya@gmail.com",
  //   "yogamaj864@gocasin.com",
  //   "lashionrobinson@gmail.com"
  // ]
  // const validEmail = email ? emails.includes(email) || email.includes("@mailinator.com") : false;
  const validEmail = true;
  const validUserType = user_type !== "podcaster";
  return validEmail && validUserType;
};

export const getUserNameFromURL = (url) => {
  const username = url.split("/");
  return username[username.length - 1];
};

export const checkValidSocialMedia = (slug) => {
  const validOptions = ["tiktok", "instagram", "twitter", "facebook"];
  return validOptions.includes(slug);
};

export const checkAtSign = (slug) => {
  return slug.includes("@");
};

export const getFormetedUrl = (url) => {
  if (url.includes("https://") || url.includes("http://")) {
    return url;
  } else {
    return `https://${url}`;
  }
};

export const replaceAtMentionsWithLinks = (text) => {
  return text.replaceAll(/@([^/.,\\ ]+)/gi, '<a href="/$1">@$1</a>');
};

export const getDaysBetweenDates = (startDate, endDate) => {
  // Create Date objects for both dates
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Get the time in milliseconds for both dates
  const startTime = start.getTime();
  const endTime = end.getTime();

  // Calculate the difference in milliseconds
  const differenceInMilliseconds = endTime - startTime;

  // Convert milliseconds to days (1000 ms/s * 60 s/min * 60 min/hr * 24 hr/day)
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const differenceInDays = differenceInMilliseconds / millisecondsPerDay;

  return differenceInDays;
};
